
import Header from './components/Header';
import Hero from './components/Hero';
import Mission from './components/Mission';
import Services from './components/Services';
import Guarantees from './components/Guarantees';
import ServiceArea from './components/ServiceArea';
import Testimonials from './components/Testimonials';
import CTA from './components/CTA';
import Contact from './components/Contact';
import Footer from './components/Footer';

export default function Home() {
  return (
    <div className="min-h-screen bg-white font-nunito">
      <Header />
      <main>
        <Hero />
        <Mission />
        <Services />
        <Guarantees />
        <ServiceArea />
        <Testimonials />
        <CTA />
        <Contact />
      </main>
      <Footer />
    </div>
  );
}
